import React, { useContext, useEffect } from "react";
import venomContext from "../../context/venomContext";

export default function QuickInfoCards() {
  const context = useContext(venomContext);
  const { getTotalUsers, usersTotal, blogs, categories } = context;
  const theme_color = localStorage.getItem("theme");
  useEffect(() => {
    getTotalUsers();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="quick-info-cards">
        <div className="cards">
          <div className="info-card d-flex align-items-center">
            <i className={"fal fa-users bg-" + theme_color}></i>
            <div className="card-content">
              <h4>Total Users</h4>
              <p>{usersTotal.total > 0 ? usersTotal.total : 0}</p>
            </div>
          </div>
          <div className="info-card d-flex align-items-center">
            <i className={"fal fa-blog bg-" + theme_color}></i>
            <div className="card-content">
              <h4>Total Blogs</h4>
              <p>{blogs.total > 0 ? blogs.total : 0}</p>
            </div>
          </div>
          <div className="info-card d-flex align-items-center">
            <i className={"fas fa-tilde bg-" + theme_color}></i>
            <div className="card-content">
              <h4>Total Categories</h4>
              <p>{categories.total > 0 ? categories.total : 0}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
